<template>
  <v-layout row wrap mb-4 pa-0>
    <case-header-new></case-header-new>
    <v-flex xs12 px-0>
      <v-layout wrap class="px-4 py-4 mb-0 ">
        <v-flex xs12 px-4 pb-3>
          <h2 class="pt-4" style="float:left">Timeline</h2>
          <v-btn
            @click="dialogNotifications = true"
            style="float:right"
            class="ma-0 mt-3 pt-1"
            color="secondary">
            <span v-if="hasSubscriptions">Edit notifications</span>
            <span v-else> Turn on notifications</span>
          </v-btn>
        </v-flex>
        <v-flex xs12 px-4>
          <Timeline :timeline-days="timelineDays" :isCaseTimeline="true"></Timeline>
        </v-flex>
      </v-layout>
    </v-flex>
    <v-dialog v-model="dialogNotifications" max-width="500">
      <v-card class="pa-4">
        <v-card-title class="pa-0 pb-2">
          <h2 v-if="hasSubscriptions">Edit notifications for this case</h2>
          <h2 v-else>Turn on notifications for this case</h2>
        </v-card-title>
        <v-card-text class="pa-0">
          <p>Select the timeline events you want to receive notifications for.</p>
          <v-checkbox v-model="allEvents" class="ma-0" color="secondary" label="Toggle all"></v-checkbox>
          <v-checkbox v-model="updateEvent" class="ma-0" color="secondary" label="Updated"></v-checkbox>
          <v-checkbox v-model="statusEvent" class="ma-0" color="secondary" label="Status change"></v-checkbox>
          <v-checkbox v-model="taskEvent" class="ma-0" color="secondary" label="Tasks"></v-checkbox>
          <v-checkbox v-model="documentEvent" class="ma-0" color="secondary" label="Documents"></v-checkbox>
          <v-checkbox v-model="conversationEvent" class="ma-0" color="secondary" label="Conversations"></v-checkbox>
          <v-checkbox v-model="createEvent" class="ma-0" color="secondary" label="Created"></v-checkbox>
          <v-checkbox v-model="viewEvent" class="ma-0" color="secondary" label="Viewed"></v-checkbox>
        </v-card-text>
        <v-card-actions class="ma-0 pa-0 pt-1">
          <v-btn @click="notificationsUpdate()" color="success">
            <span v-if="hasSubscriptions">Save Changes</span>
            <span v-else>Save</span>
          </v-btn>
          <v-btn @click="cancelNotificationsUpdate()" color="secondary">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import { normaliseEventType } from "@/stores/timeline/eventTypes"
import { mapState } from 'vuex'
import Vue from 'vue'
import CaseHeaderNew from "@/components/cases/case-edit/CaseHeaderNew"
import Timeline from "@/components/timeline/Timeline.vue"

export default {
  name: "case-timeline",
  components: { CaseHeaderNew, Timeline },
  data: () => ({
    dialogNotifications: false,
    updateEvent: false,
    statusEvent: false,
    taskEvent: false,
    documentEvent: false,
    conversationEvent: false,
    createEvent: false,
    viewEvent: false
  }),
  computed: {
    ...mapState({
      timelineDays: state => state.timeline.current,
      currentUser: state => state.currentUser,
      currentCaseId: state => state.cbroute.params.case_id
    }),
    hasSubscriptions() {
      return (this.updateEvent || this.statusEvent || this.taskEvent || this.documentEvent || this.conversationEvent || this.createEvent || this.viewEvent)
    },
    allEvents: {
      get() {
        return (this.updateEvent && this.statusEvent && this.taskEvent && this.documentEvent && this.conversationEvent && this.createEvent && this.viewEvent)
      },
      set(value) {
        this.updateEvent = value
        this.statusEvent = value
        this.taskEvent = value
        this.documentEvent = value
        this.conversationEvent = value
        this.createEvent = value
        this.viewEvent = value
      }
    },
    subscriptions() {
      let caseSubs = []
      if (this.currentUser.subscriptions) {
        caseSubs = this.currentUser.subscriptions.filter((sub) => sub.case.id === this.currentCaseId)
        this.updateEvents(caseSubs)
      }
      return caseSubs
    }
  },
  created() {
    this.updateEvents(this.subscriptions) // Force subscription setup on refresh
  },
  methods: {
    updateEvents(caseSubs) {
      this.updateEvent = false
      this.statusEvent = false
      this.taskEvent = false
      this.documentEvent = false
      this.conversationEvent = false
      this.createEvent = false
      this.viewEvent = false
      caseSubs.forEach(sub => {
        switch (normaliseEventType(sub.eventType)) {
          case "case.updated":
            this.updateEvent = true
            break
          case "status_case":
            this.statusEvent = true
            break
          case "task_case":
            this.taskEvent = true
            break
          case "document_case":
            this.documentEvent = true
            break
          case "conversation_case":
            this.conversationEvent = true
            break
          case "case.created":
            this.createEvent = true
            break
          case "case.read":
            this.viewEvent = true
            break
        }
      })
    },
    async notificationsUpdate() {
      const selected = []
      const unselected = []
      if (this.updateEvent) { selected.push("case.updated") } else { unselected.push("case.updated") }
      if (this.statusEvent) { selected.push("status_case") } else { unselected.push("status_case") }
      if (this.taskEvent) { selected.push("task_case") } else { unselected.push("task_case") }
      if (this.documentEvent) { selected.push("document_case") } else { unselected.push("document_case") }
      if (this.conversationEvent) { selected.push("conversation_case") } else { unselected.push("conversation_case") }
      if (this.createEvent) { selected.push("case.created") } else { unselected.push("case.created") }
      if (this.viewEvent) { selected.push("case.read") } else { unselected.push("case.read") }

      const caseSubs = this.currentUser.subscriptions.filter((sub) => sub.case.id === this.currentCaseId)
      const subTypes = caseSubs.map(sub => normaliseEventType(sub.eventType))
      const updateSubs = selected.filter((sub) => !subTypes.includes(sub))
      const updateUnSubs = unselected.filter((sub) => subTypes.includes(sub))

      this.dialogNotifications = false
      const [subSuccess, unsubSuccess] = await Promise.all([
        this.$store.dispatch("subscribeToCaseEvents", { caseId: parseInt(this.currentCaseId), eventTypes: updateSubs }),
        this.$store.dispatch("unsubscribeFromCaseEvents", { caseId: parseInt(this.currentCaseId), eventTypes: updateUnSubs }),
      ])
      if (subSuccess && unsubSuccess) {
        this.$store.commit("displayFlashMessage", { message: "Successfully updated notification subscriptions", severity: "success" })
      }
      await this.$store.dispatch('requestCurrentUser')
    },
    cancelNotificationsUpdate() {
      this.dialogNotifications = false
      this.updateEvents(this.subscriptions)
    }
  },
  beforeRouteLeave(to, from, next) {
    const state = Vue.store.state
    const currentUser = Object.assign(state.currentUser.me, { account: { id: state.currentUser.account.id } })
    Vue.store.dispatch("unsubscribeToCaseChannelV2", { caseId: from.params.case_id, currentUser: currentUser })
    next()
  },
  beforeRouteEnter(to, from, next) {
    const state = Vue.store.state
    const currentUser = Object.assign(state.currentUser.me, { account: { id: state.currentUser.account.id } })
    Vue.store.dispatch("subscribeToCaseChannelV2", { caseId: to.params.case_id, currentUser })
    next()
  }
}
</script>